import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EarbudsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"earbuds"}/>
}
